import React from 'react';
import { Landing } from './pages/Landing';
type BrandLockup = 'nombre-comercial' | 'descriptivo';
interface AppProps {
  /** Cómo se presenta la marca en el header y el footer. */
  brandLockup?: BrandLockup;
  /** Mostrar la sección de experiencias (solo con testimonios reales autorizados). */
  showTestimonials?: boolean;
  /** Mostrar la cifra de consultas y rituales (solo si está documentada). */
  showConsultationCount?: boolean;
  /** Mostrar "Consulta inicial sin costo." (solo si la consulta no tiene costo obligatorio). */
  freeInitialConsultation?: boolean;
}
const LOCKUPS: Record<BrandLockup, string> = {
  'nombre-comercial': 'Resultados en Horas',
  descriptivo: 'Rituales y Orientación Espiritual'
};
export function App({
  brandLockup = 'descriptivo',
  showTestimonials = true,
  showConsultationCount = true,
  freeInitialConsultation = true
}: AppProps) {
  return <Landing lockup={LOCKUPS[brandLockup]} showTestimonials={showTestimonials} showConsultationCount={showConsultationCount} freeInitialConsultation={freeInitialConsultation} data-id="element-0" data-mp="23vuokdaowwv5" />;
}